module.exports = __webpack_public_path__ + "img/zmu.3387f935.svg";